/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from './dialog';
import { push } from 'connected-react-router';
import get from 'lodash/get';
import GetAppIcon from '@material-ui/icons/GetApp';
import { EUROPE } from 'enums/regions';
import { useIntl } from 'react-intl';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { DropzoneDialog } from 'material-ui-dropzone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { toast } from 'react-toastify';
import toastConfig from 'enums/toast';
import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

const useStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const Actions = ({ push, value, row }) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [open, setOpen] = useState(false);
  const intl = useIntl();
  const [fileName, setFileName] = useState('');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const isClient = get(row, 'data.status', '') === 'Cliente';
  const isClosed = row.isClosed;

  const isDinoc = row.subtype === 'Dinoc' || row.subtype === 'DinocSmall';
  const isFasara = row.subtype === 'Fasara' || row.subtype === 'FasaraSmall';
  const isAproved = row.isApproved;
  const { code } = row;

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        &bull;&bull;&bull;
      </Button>

      {isClosed && isDinoc ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {!isAproved ? (
              <>
                {' '}
                <MenuItem
                  onClick={() => push(`/distributor/arqFinishes/view/${value}`)}
                >
                  <VisibilityIcon className={classes.icon} />
                  <FormattedMessage id="Ver" />
                </MenuItem>
                {!Boolean(code) && (
                  <MenuItem
                    onClick={() =>
                      push(`/distributor/arqFinishes/warranty/${value}`)
                    }
                  >
                    <AssignmentTurnedInIcon className={classes.icon} />
                    <FormattedMessage id="Otorgar certificado de garantia" />
                  </MenuItem>
                )}
              </>
            ) : (
              <>
                <MenuItem
                  onClick={() => push(`/distributor/arqFinishes/view/${value}`)}
                >
                  <VisibilityIcon className={classes.icon} />
                  <FormattedMessage id="Ver" />
                </MenuItem>
                <MenuItem onClick={handleOpenDialog}>
                  <MailOutlineIcon className={classes.icon} />
                  <FormattedMessage id="Volver a enviar cert de garantía" />
                </MenuItem>
              </>
            )}
            {openDialog && (
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                code={value}
              />
            )}
          </Menu>
        </>
      ) : isClosed && isFasara ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {!isAproved ? (
              <>
                <MenuItem
                  onClick={() => push(`/distributor/arqFinishes/view/${value}`)}
                >
                  <VisibilityIcon className={classes.icon} />
                  <FormattedMessage id="Ver" />
                </MenuItem>
                {!Boolean(code) && (
                  <MenuItem
                    onClick={() =>
                      push(`/distributor/arqFinishes/warranty/${value}`)
                    }
                  >
                    <AssignmentTurnedInIcon className={classes.icon} />
                    <FormattedMessage id="Otorgar certificado de garantia" />
                  </MenuItem>
                )}
              </>
            ) : (
              <>
                <MenuItem
                  onClick={() => push(`/distributor/arqFinishes/view/${value}`)}
                >
                  <VisibilityIcon className={classes.icon} />
                  <FormattedMessage id="Ver" />
                </MenuItem>
                <MenuItem onClick={handleOpenDialog}>
                  <MailOutlineIcon className={classes.icon} />
                  <FormattedMessage id="Volver a enviar cert de garantía" />
                </MenuItem>
              </>
            )}
            {openDialog && (
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                code={value}
              />
            )}
          </Menu>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default connect(undefined, { push })(Actions);
